package pwgs.ui.scenes.projectmembersscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.utils.EHAlign

class MProjectMembersScene(props: ProjectMembersSceneProps) : AScene<ProjectMembersSceneProps, ProjectMembersSceneModel, ProjectMembersSceneState, ProjectMembersControllerFe>(props) {

    override fun createController() : ProjectMembersControllerFe {
        return ProjectMembersControllerFe(props, this)
    }

    override fun initState() : ProjectMembersSceneState {
        return ProjectMembersSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MProjectMembersScene.model
        Card {
            isLoading = m.isLoading
            header("Members") {

            }
            body {
                Table {
                    columns {
                        fixedColumn("Name")
                        fixedColumn("Email")
                        fixedColumn("Level")
                        fixedColumn("", hAlign = EHAlign.Right)
                    }

                    body {
                        m.members.forEach { member ->
                            row {
                                cell(member.userName)
                                cell(member.email)
                                cell(member.userLevel.name)
                                cell {
                                    IconButton("delete") {
                                        variant = EButtonVariant.Link
                                        size = EButtonSize.Small
                                        color = EButtonColor.Danger
                                        onClick = {this@MProjectMembersScene.controller.onRemoveMemberClicked(member.userId)}
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class ProjectMembersSceneState {

}

fun Components.ProjectMembersScene(props: ProjectMembersSceneProps) = this.registerComponent(MProjectMembersScene(props), {})
